export type AppStorePlatform = 'android' | 'ios' | 'macos' | 'other'

/**
 * Classify only what is needed for CTA routing and reporting. This deliberately
 * avoids high-entropy device details: analytics receives a four-value bucket,
 * never the raw user agent.
 */
export function classifyAppStorePlatform(userAgent: string): AppStorePlatform {
  if (/android/i.test(userAgent)) return 'android'
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios'
  if (/macintosh|mac os x/i.test(userAgent)) return 'macos'
  return 'other'
}
